'use strict';
(function () {
	angular
		.module('onboarding.common')
		.directive('cobPagination', cobPagination);

	cobPagination.$inject = [];

	function cobPagination() {
		return {
			restrict: 'E',
			scope: {
				currentPage: '=',
				offset: '=',
				pageLimit: '=',
				pageLimits: '=',
				total: '=',
				onUpdate: '&'
			},
			templateUrl: '/app/common/directives/cobPagination.html',
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {
			scope.nextPage = nextPage;
			scope.previousPage = previousPage;
			scope.getTotalPages = getTotalPages;
			scope.isCurrentPageLimit = isCurrentPageLimit;
			scope.getRangeLabel = getRangeLabel;
		}

		function nextPage() {
			scope.currentPage += 1;
			scope.offset = scope.currentPage * scope.pageLimit;
			invokeCallback();
		}

		function previousPage() {
			if (scope.currentPage === 0) {
				return;
			}
            
			scope.currentPage -= 1;
			scope.offset = scope.currentPage * scope.pageLimit;
			invokeCallback();
		}

		function getTotalPages() {
			return Math.ceil(scope.total / scope.pageLimit);
		}

		function getRangeLabel(page, pageSize, length) {
			if (length == 0 || pageSize == 0) { 
				return '0 of ' + length;
			}
        
			length = Math.max(length, 0);
        
			var startIndex = page * pageSize;
        
			// If the start index exceeds the list length, do not try and fix the end index to the end.
			var endIndex = startIndex < length ?
				Math.min(startIndex + pageSize, length) :
				startIndex + pageSize;
        
			return 'Files ' + ++startIndex + ' – ' + endIndex + ' from ' + length;
		}

		function isCurrentPageLimit(value) {
			return scope.pageLimit == value;
		}

		function invokeCallback() {
			if (scope.onUpdate) {
				scope.onUpdate({
					offset: scope.offset
				});
			}
		}
	}
})();
